<div class="oiq-ui-dialog">
  <header>
    <div class="__title">
      <span class="material-symbols-outlined flex-grow-0">calendar_today</span>
      <div>
        <h2>
          <span>{{ data.id ? data.entityName : 'New' }} Event</span>
        </h2>
      </div>
      <button (click)="closeDialog(true)" class="oiq-button oiq-button--link __close" type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>
  <main>
    <oiq-notification-form></oiq-notification-form>
  </main>
  <footer>
    <div class="__left"><!-- LEFT --></div>
    <div class="__right">
      <button class="oiq-button oiq-button--primary--outline" (click)="closeDialog(false)">
        Cancel
      </button>
      @if (ctrlRef) {
        <button
          class="oiq-button oiq-button--primary--solid"
          (click)="onSubmit()"
          [disabled]="ctrlRef.form.invalid">
          Save
        </button>
      }
    </div>
  </footer>
</div>
